import { useState } from "react";
import { Route, Switch } from "react-router-dom";
import routing from "routing";
import { LiveUpdateListener } from "src/components/LiveUpdateListener";
import { ModalProvider } from "src/components/Modals/context/ModalProvider";
import App from "src/containers/App";
import { useGetUserInfo } from "src/hooks/useUser";
import ResetPassword from "./components/NewComponents/Auth/resetPassword";
import SetNewPassword from "./components/NewComponents/Auth/resetPassword/SetNewPassword";
import SetPasswordError from "./components/NewComponents/Auth/resetPassword/SetPasswordError";
import SuccessResetPassword from "./components/NewComponents/Auth/resetPassword/SuccessResetPassword";

import SignIn from "./components/NewComponents/Auth/SignIn";
import SignUp from "./components/NewComponents/Auth/SignUp";
import { DefaultExam } from "./components/NewComponents/Exam/ExamView/DefaultExam";
import { PaymentRequiredModal } from "./components/NewComponents/Modals/PaymentRequiredModal";
import SetSpecialisationModal from "./components/NewComponents/Modals/SetSpecialisationModal";
import { WrongServiceModal } from "./components/NewComponents/Modals/WrongServiceModal";
import { ChatWidget } from "./containers/ChatWidget";
import GenerateExam from "./containers/NewContainers/GenerateExam";
import { getWrongServiceTarget } from "./helpers/getPermissions";
import { useHasRequiredCookies } from "./helpers/hasRequiredCookies";
import { useGetAppConfig } from "./hooks/useAppConfig";
import useIsAuthPage from "./hooks/useIsAuthPage";
import useTheme from "./hooks/useTheme";

function Router() {
	useTheme();
	const isAuthPage = useIsAuthPage();
	const hasCookies = useHasRequiredCookies(!isAuthPage);
	const { isLoading, isFetched } = useGetUserInfo(!isAuthPage);
	const { isLoading: isConfigLoading } = useGetAppConfig(isFetched);
	const [stayOnWrongService, setStayOnWrongService] = useState(false);

	if (!hasCookies || isLoading || isConfigLoading) {
		return null;
	}

	const renderModals = () => {
		if (isAuthPage) {
			return null;
		}

		const wrongServiceTarget = getWrongServiceTarget();

		if (wrongServiceTarget && !stayOnWrongService) {
			return (
				<WrongServiceModal
					targetService={wrongServiceTarget}
					onStay={() => setStayOnWrongService(true)}
				/>
			);
		}

		return (
			<>
				<SetSpecialisationModal />
				<PaymentRequiredModal />
			</>
		);
	};

	return (
		<ModalProvider>
			<LiveUpdateListener />
			{renderModals()}
			<Switch>
				<Route path={routing.paths.signIn} component={SignIn} />
				<Route path={routing.paths.signUp} component={SignUp} />
				<Route
					path={routing.paths.successResetPassword}
					component={SuccessResetPassword}
				/>
				<Route path={routing.paths.setNewPassword} component={SetNewPassword} />
				<Route
					path={routing.paths.setPasswordError}
					component={SetPasswordError}
				/>
				<Route path={routing.paths.resetPassword} component={ResetPassword} />
				<Route path={routing.paths.generateExam} component={GenerateExam} />
				<Route path={routing.paths.exam} component={DefaultExam} />
				<Route path={routing.paths.chatWidget} component={ChatWidget} />
				<Route path={routing.paths.home} component={App} />
			</Switch>
		</ModalProvider>
	);
}

export default Router;
